import * as React from 'react';
import * as styles from './NewsCard.css';

interface INewsCardProps {
  title: React.ReactNode;
  date: React.ReactNode;
}

export function NewsCard({ title, date }: INewsCardProps) {
  return (
    <article className={styles['card']} data-testid="NewsCard">
      <div data-testid="NewsCardTitle">{title}</div>
      <span data-testid="NewsCardDate">{date}</span>
    </article>
  );
}
